import { React, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFAutocomplete, RHFCheckbox, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import axiosInstance from 'src/api/axiosInstance';
import { getCurrentProject, getCurrentServer, getMandEndPoint } from 'src/helper/server-address';
import * as Yup from 'yup';

export default function EmergencyContactNewEditForm({ relshnData, countryArr }) {
  const token = sessionStorage.getItem('token');
  const [stateArr, setStateArr] = useState([]);
  const [cityArr, setCityArr] = useState([]);
  const { control, setValue, watch, resetField } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'empEmrgncyContact',
  });


  const handleAdd = () => {
    append({
      cntctSrno: 0,
      name: '',
      relationship: null,
      email: '',
      mobno: '',
      curAddLn1: '',
      curAddLn2: '',
      curAddCntr: null,
      curAddState: null,
      curAddCity: null,
      curAddLandMrk: '',
      curAddZip: '',
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };
  const handleCountryChange = (selectedCountryId) => {
    axiosInstance
      .get(
        `/rest/state/findStates?countryId=${selectedCountryId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setStateArr(res.data);
      })
      .catch(() => {
        console.log('the promise is rejected');
        setStateArr([]);
      });
  };
  const handleStateChange = (selectedStateId) => {
    axiosInstance
      .get(
        `/rest/cities/findCities?stateId=${selectedStateId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setCityArr(res.data);
      })
      .catch(() => {
        console.log('the promise is rejected');
        setCityArr([]);
      });
  };
  return (
    <>
      <Box
        mt={4}
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
        }}
        mb={3}
      >
        {/* <Typography variant="subtitle2" sx={{ mb: '10px' }}>
          Emergency Contact:
        </Typography> */}
        <Box>
          <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
            Emergency Contact Details:
          </Typography>
        </Box>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add Contact
          </Button>
        </Stack>
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={2}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5}>
            <Typography variant="subtitle2" sx={{ color: 'primary', mb: 1 }}>
              Contact {index + 1}:
            </Typography>
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
              <RHFTextField name={`empEmrgncyContact[${index}].cntctSrno`} />
            </Box>
            <Box
              rowGap={2}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <Stack mb={1.5}>
                <RHFTextField
                  name={`empEmrgncyContact[${index}].name`}
                  label={
                    <div>
                      Full Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empEmrgncyContact[${index}].relationship`}
                  placeholder="Relationship"
                  label="Relationship"
                  options={relshnData}
                  showPlusIcon
                  getOptionLabel={(option) => option.masterName || ''}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
              <RHFTextField
                name={`empEmrgncyContact[${index}].email`}
                label={
                  <div>
                    Email<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
                sx={{ mt: -1.5 }}
              />
              <RHFTextField
                name={`empEmrgncyContact[${index}].mobno`}
                label={
                  <div>
                    Contact Number
                    <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
                type="number"
                sx={{ mt: -1.5 }}
                onWheel={(e) => e.target.blur()}
              />
              <RHFTextField name={`empEmrgncyContact[${index}].curAddLn1`} label="Address Line 1" />
              <RHFTextField name={`empEmrgncyContact[${index}].curAddLn2`} label="Address Line 2" />
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empEmrgncyContact[${index}].curAddCntr`}
                  placeholder="Country"
                  label={
                    <div>
                      Country
                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={countryArr}
                  disableClearable
                  getOptionLabel={(option) => option.countryName}
                  onChange={(event, value) => {
                    setValue(`empEmrgncyContact[${index}].curAddCntr`, value, {
                      shouldValidate: true,
                    });
                    setValue(`empEmrgncyContact[${index}].curAddState`, null, {
                      shouldValidate: true,
                    });
                    setValue(`empEmrgncyContact[${index}].curAddCity`, null, {
                      shouldValidate: true,
                    });
                    handleCountryChange(value.countriesId);
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.shortName}>
                      {option.countryName}
                    </li>
                  )}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empEmrgncyContact[${index}].curAddState`}
                  placeholder="State"
                  label={
                    <div>
                      State
                      {stateArr.length > 0 && (
                        <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                      )}
                    </div>
                  }
                  disableClearable
                  options={stateArr}
                  getOptionLabel={(option) => option.stateName}
                  onChange={(event, value) => {
                    setValue(`empEmrgncyContact[${index}].curAddState`, value, {
                      shouldValidate: true,
                    });
                    setValue(`empEmrgncyContact[${index}].curAddCity`, null, {
                      shouldValidate: true,
                    });
                    handleStateChange(value.statesId);
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.statesId}>
                      {option.stateName}
                    </li>
                  )}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empEmrgncyContact[${index}].curAddCity`}
                  placeholder="City"
                  label={
                    <div>
                      City
                      {cityArr.length > 0 && (
                        <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                      )}
                    </div>
                  }
                  disableClearable
                  options={cityArr}
                  getOptionLabel={(option) => option.cityName}
                  renderOption={(props, option) => (
                    <li {...props} key={option.cityId}>
                      {option.cityName}
                    </li>
                  )}
                />
              </Stack>
              <RHFTextField name={`empEmrgncyContact[${index}].curAddLandMrk`} label="Landmark" />
              <RHFTextField name={`empEmrgncyContact[${index}].curAddZip`} label="Zip Code" inputProps={{
                inputMode: 'numeric', // Mobile keyboard shows numbers
                pattern: '[0-9]*', // HTML pattern to accept only digits
                maxLength: 6, //  limit to 6 digits max
              }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Removes non-numeric chars
                }} />
            </Box>
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              alignItems={{ xs: 'flex-end', md: 'center' }}
              justifyContent="flex-end"
            >
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
EmergencyContactNewEditForm.propTypes = {
  relshnData: PropTypes.array,
  countryArr: PropTypes.array,
};
